var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer-box"}},[_vm._v("2024")])
}
var staticRenderFns = []

export { render, staticRenderFns }